import { FacetName, FilterName } from '../../../__generated__/fed-graphql-types'
import { withFacetContext } from '../../hocs/facet.context.hoc'
import { withFilterContext } from '../../hocs/filter.context.hoc'
import { Channel } from '@at/sauron-platform-core'
import { SearchFiltersByKeywords } from '../../../components/search-filters-by-keywords/search-filters-by-keywords'

export const Keywords = withFacetContext(
    FacetName.keywords,
    withFilterContext(FilterName.keywords, SearchFiltersByKeywords, {
        title: 'Add keywords',
    })
)

export const getKeywordsPlaceholder = (channel: Channel) => {
    switch (channel) {
        case Channel.cars:
            return 'e.g. sunroof, heated seats'
        case Channel.vans:
            return 'e.g. ply lined, sport'
        case Channel.bikes:
            return 'e.g. ABS, DCT'
        case Channel.motorhomes:
            return 'e.g. garage, shower'
        case Channel.caravans:
            return 'e.g. motor mover, shower'
        case Channel.trucks:
            return 'e.g. axor tipper'
        case Channel.farm:
            return 'e.g. john deere tractor'
        case Channel.plant:
            return 'e.g. kamatsu excavator'
        default:
            return 'e.g. brand, model'
    }
}
